// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Switch__wrapper__ZhtY_","root":"Switch__root__1nxls","track":"Switch__track__1Hn_k","thumb":"Switch__thumb__3GQRu","checked":"Switch__checked__97xos"};